import React from 'react';
import { Box, Container, Grid, Paper, Stack, Typography, Alert, CircularProgress } from '@mui/material';
import { Groups as GroupsIcon } from '@mui/icons-material';
import MainLayout from '../../../components/layout/MainLayout';
import { staffApi, Designation, Department } from '../api';

const DesignationsPage: React.FC = () => {
  const [designations, setDesignations] = React.useState<Designation[]>([]);
  const [departments, setDepartments] = React.useState<Department[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    setError('');
    try {
      const [desgn, depts] = await Promise.all([
        staffApi.listDesignations(),
        staffApi.listDepartments(),
      ]);
      setDesignations(desgn);
      setDepartments(depts);
    } catch (err: any) {
      setError(err.message || 'Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'flex-start', sm: 'center' }} spacing={2} sx={{ mb: 3 }}>
          <Box>
            <h2 style={{ margin: 0 }}>Designations</h2>
            <p style={{ margin: '4px 0 0 0', color: '#666', fontSize: '14px' }}>View job titles and reporting hierarchy</p>
          </Box>
        </Stack>

        {error ? <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert> : null}

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={2}>
            {designations.map((desig) => (
              <Grid key={desig.id} item xs={12} sm={6} md={4}>
                <Paper sx={{ p: 2.5, borderRadius: 2, cursor: 'pointer', '&:hover': { boxShadow: 3 } }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>{desig.name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {desig.department?.name || 'No department mapped'}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </MainLayout>
  );
};

export default DesignationsPage;
